import * as angular from 'angular';
import { StateParams, StateService } from '@uirouter/angularjs';
import { UrlService } from '../../services/url.service';

declare function amp(id: any, options?: any, ready?: Function): any;

function directive($rootScope: ng.IRootScopeService, $state: StateService, $stateParams: StateParams, urlService: UrlService, $window: ng.IWindowService, $timeout: ng.ITimeoutService ) {

    return {
        restrict: 'A',
        template: require('./videojs.directive.html'),
        require: 'ngModel',
        scope: {
            ngModel: '=',
            identifier: '=',
            fixedWidth: '=?',
            maxWidth: '=?',
            maxHeight: '=?',
            autoinit: '=?',
            autoplay: '=?',
            videoContainer : '=?'
        },
        link: function ($scope: ng.IScope & any, element: JQLite, attrs: ng.IAttributes, ctrl: ng.IController) {
            $scope.video = $scope.ngModel;
            $scope.htmlElementID = $scope.identifier;
            $scope.videoContainer = ($scope.videoContainer) ? $scope.videoContainer : '#videoContainer';

            $scope.getPlayerHeight = (fixedWidth: number) => {
                if (!fixedWidth) {
                    fixedWidth = 870; // dashboard max
                }

                if (!$scope.maxHeight) {
                    $scope.maxHeight = fixedWidth * 1.25;
                }

                var minHeight = fixedWidth * 0.5;

                var width = $scope.video.Width;
                var height = $scope.video.Height;

                var newHeight: number;

                if (width >= height) {
                    var ratio = width / fixedWidth;
                    newHeight = height / ratio;
                } else {
                    newHeight = height;
                }

                if (newHeight > $scope.maxHeight) {
                    newHeight = $scope.maxHeight;
                } else if (newHeight < minHeight) {
                    newHeight = minHeight;
                }

                return newHeight;
            };

            $scope.getVideoWidth = () => {
                var width = $($scope.videoContainer).width();
                return width > $scope.maxWidth ? $scope.maxWidth : width;
            };

            $scope.resizePlayer = () => {
                var width = $scope.getVideoWidth();
                if (width) {
                    $scope.fixedWidth = width;
                    $scope.currentHeight = $scope.getPlayerHeight(width);
                    if ($scope.player) {
                        $scope.player.width($scope.fixedWidth);
                        $scope.player.height($scope.currentHeight);
                    }
                }
            };

            if (!$scope.fixedWidth) {
                var w = angular.element($window);
                $scope.getWindowDimensions = function () {
                    return {
                        'h': w.height(),
                        'w': w.width()
                    };
                };
                $scope.$watch($scope.getWindowDimensions, function (newValue: any, oldValue: any) {
                    $scope.resizePlayer();
                }, true);

                $scope.$watch(() => { return $scope.getVideoWidth(); }, (newValue: any, oldValue: any) => {
                    $scope.resizePlayer();
                }, true);

                w.bind('resize', function () {
                    $scope.$apply();
                });

                $scope.resizePlayer();
            }

            $scope.currentHeight = $scope.getPlayerHeight($scope.fixedWidth);

            $scope.selfUrl = $state.href($state.current.name, $stateParams, { absolute: true });

            if (typeof $scope.autoinit === 'undefined') {
                $scope.autoinit = false;
            }

            if (typeof $scope.autoplay === 'undefined') {
                $scope.autoplay = true;
            }

            $scope.videoPlayerLoaded = false;

            $scope.initVideoPlayer = async () => {
                var videoUrl = $scope.video.VideoUrl || $scope.video.TeaserUrl;

                if (videoUrl && !$scope.videoPlayerLoaded) {

                    $scope.videoPlayerLoaded = true;
                    await $timeout(0);

                    var playerID = ($scope.autoinit) ? 'videoplayer' : 'videoplayer_' + $scope.video.ID + '_' + $scope.htmlElementID;

                    var options = {
                        'nativeControlsForTouch': true,
                        controls: true,
                        autoplay: $scope.autoplay,
                        width: $scope.fixedWidth,
                        height: $scope.currentHeight,
                        logo: { enabled: false }
                    };

                    var elementVideo = document.getElementById(playerID);

                    $scope.player = amp(elementVideo, options);
                    $scope.player.src([
                        {
                            'src': videoUrl,
                            'type': 'video/mp4' // 'application/vnd.ms-sstr+xml'
                        }
                    ]);
                }
            };

            if ($scope.autoinit) {
                $scope.initVideoPlayer();
            }
        }
    };
}

angular.module('app.common').directive('videojs', directive); // TODO rework to component

directive.$inject = ['$rootScope', '$state', '$stateParams', 'urlService', '$window', '$timeout'];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/video/videojs.directive.ts